export default function timestampToDate (timestamp: number) {
  console.log(typeof timestamp);
  if (timestamp <= 0) return '0天0小时0分钟';
  let days = Math.floor(timestamp / 86400);
  let hours = Math.floor((timestamp - (days * 86400)) / 3600);
  let minutes = Math.floor((timestamp - (days * 86400) - (hours * 3600)) / 60);
  
  return `${days}天${hours}小时${minutes}分钟`
}


export function minutestoDate (time: number) {
  let hours = Math.floor(time / 60);
  let minutes = Math.floor((time - (hours * 60)) );
  return `${hours}:${minutes}`
}